<template>
    <div @click="donationTypeSelected(option)" class="donation-details">
      <div class="donation-option-details" v-if="option">
        <img src="/static/images/donation-box.png" class="donation-box"/>
        <div>
            <img :src="option.image" class="donation-type-img" :id="'image-'+option.id"/>
        </div>
        <div class="title">{{option.title | translate}}</div>
      </div>
        <!-- <div class="desc">{{option.description | translate}}</div>
        <div class="continue"> {{`Continue` | translate}} &#8250;</div> -->
    </div>
</template>
<script>

export default {
  data () {
    return {
    }
  },
  props: ['option'],
  computed: {
  },
  methods: {
    donationTypeSelected (donationType) {
      this.$emit('clickOption', donationType)
    }
  },
  components: {
  },
  mounted: function () {
  }
}
</script>
<style scoped>
    .donation-details {
      /* background-image: url('/static/images/donation-box.png'); */
      background-repeat: no-repeat;
      /* height: 160px; */
      display: flex;
      align-items: center;
      justify-content: center;
      width: 80%;
      z-index: 2;
    }
    div[dir='rtl'] .donation-details {
      margin-left: 15%;
    }

    .donation-details img.donation-type-img {
        width: 45px;
        margin-right: 15px;
        z-index: 4;
        margin-left: 10px;
    }
    .donation-details #image-1 {
      margin-top: 15px;
    }
    div.donation-details .title {
        font-size: 25px;
        color: #eca861;
        text-shadow: 0px 0px 5px #512806;
        justify-content: center;
        border-radius: 2px;
        transition: all 0.3s ease-out 0s;
        text-shadow: -1px -1px 0 #512806, 1px -1px 0 #512806, -1px 1px 0 #512806, 1px 1px 0 #512806;
        z-index: 4;
        line-height: 28px;
    }
    .donation-option-details {
      padding: 40px 0px 30px;
      /* background-color: #512806; */
      width: 75%;
      height: 100%;
      display: flex;
      align-items: center;
    }
    .donation-option-details > div {
      z-index: 4;
    }
    div[dir='rtl'] .donation-details img {
      margin-right: 0;
      margin-left: 15px;
    }
  .donation-box {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    width:75%;
    height: 75%;
  }
  @media only screen and (min-width: 2000px) {
    .donation-details {
      height: 100%;
    }
    /* .donation-option-details {
       padding-left: 12%;
      padding-right: 10%;
    } */
    .donation-details img.donation-type-img {
      width: 180px;
      margin-right: 50px;
    }
    div.donation-details .title {
      font-size: 120px;
      line-height: 120px;
      font-weight: 900;
    }
    .donation-details #image-1 {
      margin-top: 35px;
    }
    div[dir='rtl'] .donation-details img {
      margin-left: 50px;
    }
  }
 @media screen and (min-width: 1200px) and (min-height: 904px) {
    .donation-details img.donation-type-img {
      width: 45px;
    }
    div.donation-details .title {
      font-size: 40px;
      line-height: 42px;
    }
    .donation-box {
      max-height: 240px;
    }
    div.donation-details .title {
      text-shadow: -2px -2px 0 #512806, 2px -2px 0 #512806, -2px 2px 0 #512806, 2px 2px 0 #512806;
      font-size: 30px;
    }
    div[dir='rtl'] .donation-details .title {
     font-size: 38px;
    }
 }
</style>



// WEBPACK FOOTER //
// src/components/donationOption.vue